import styled from 'styled-components';
import { AZ } from '../layouts/AppLayout.styled';

export const Panel = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
`;

export const PanelHead = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: baseline;
  gap: 10px;

  strong {
    font-size: 15px;
    color: ${AZ.ink};
  }
  span {
    font-size: 12px;
    color: ${AZ.soft};
  }
`;

export const TypeTag = styled.span`
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 999px;
  color: ${(p) => p.$color};
  background: ${(p) => p.$bg};
`;
